import React from "react";
import { MdDelete } from "react-icons/md";
import { useDispatch } from "react-redux";
import { deleteOther } from "../JS/actions/other";
import "./Other.css";
const Other = ({ oth }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    const result = window.confirm("are you sure");
    if (result) {
      dispatch(deleteOther(oth._id));
    }
  };
  return (
    <div class="main-container">
      <div class="heading"></div>
      <div class="cardss">
        <div class="cardd card-7">
          <div class="card__icon">
            <b> {oth.title} </b>
            {/* <FaCalendarPlus style={{ fontSize: "29px", color: "white" }} />{" "} */}
          </div>
          <p class="card__exit">
            {/* <i class="fas fa-times"></i> */} Quantity : {oth.qte}{" "}
            {/* {secourism.description} */}
          </p>
          <p class="card__title">{oth.description}</p>
          <p class="card__apply">
            <a onClick={handleDelete} class="card__link">
              Delete Now{" "}
              <MdDelete style={{ color: "white", fontSize: "22px" }} />{" "}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Other;
